import { useEffect, useState, useCallback } from "react";
import { Map, useMap, useMapsLibrary } from "@vis.gl/react-google-maps";
import Button from "../components/Button";
import { ReactComponent as IconArrow } from "../img/icons/arrow-right.svg";

import { useDrawingManager } from "../hooks/useDrawingManager";

import getOffset from "../helpers/getOffset";
import useIncrementSimulationStep from "../hooks/useIncrementSimulationStep";

const SurfaceStep = () => {
  const {simParams, incrementSimulationStep} = useIncrementSimulationStep();
  const [surface, setSurface] = useState(null);
  const [surfaceSelectionStyle, setSurfaceSelectionStyle] = useState({left: 0, top: 0, display: 'none'});
  const [resetDM, setResetDM] = useState(false);
  const [resetVisible, setResetVisible] = useState(false);
  const [clickedPoints, setClickedPoints] = useState([]);
  const drawingManager = useDrawingManager(null, resetDM);
  const map = useMap();
  const geometry = useMapsLibrary('geometry')

  const handlePolygonComplete = useCallback((polygon) => {
    if (!geometry) return;

    setSurface(Math.round(geometry.spherical.computeArea(polygon.getPath())));

    const map = polygon.getMap();
    if (map.surface_polygon)
      map.surface_polygon.setMap(null);
    map.surface_polygon = polygon;

    var max = {x: 0, y: 0};
    var min = {x: 16384, y: 16384};
    clickedPoints.forEach((p) => {
      if (p.x > max.x) max.x = p.x;
      if (p.y > max.y) max.y = p.y;
      if (p.x < min.x) min.x = p.x;
      if (p.y < min.y) min.y = p.y;
    });

    const off = getOffset(document.querySelector('.content .left'));
    setSurfaceSelectionStyle({left: ((max.x + min.x) / 2) - off.x, top: max.y - off.y, display: 'inline-block'});
  }, [geometry, clickedPoints]);

  useEffect(() => {
    if (!drawingManager) return;

    drawingManager.addListener('polygoncomplete', handlePolygonComplete);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [drawingManager]);

  const handleReset = () => {
    if (map.surface_polygon)
      map.surface_polygon.setMap(null);
    setResetDM(!resetDM);
    setSurface(null);
    setClickedPoints([]);
    setResetVisible(false);
  };

  const handleClick = (evt) => {
    if (!clickedPoints.length) setResetVisible(true);
    clickedPoints.push({x: evt.screenX, y: evt.screenY});
  }

  const setSurfaceSelection = () => {
    if (surface)
      incrementSimulationStep({...simParams, surface: {area: surface, drawing: map.surface_polygon.getPath().getArray()}});
  };

  return (
    <>
      <div className="left" onClick={handleClick}>
        { surface && <div className="surface_selection" style={surfaceSelectionStyle}>Votre sélection fait :<br/><span>{ surface } m<sup>2</sup></span></div> }
        <Map
          zoom={21}
          tilt={0}
          mapTypeId={'satellite'}
          center={simParams.adjustedLocation}
          gestureHandling={'none'}
          disableDefaultUI={true}
          controlled={true}
          >
        </Map>
      </div>
      <div className="right">
        <div className="text">
          <h2>Quelle est la surface de toit 📐 pour poser vos panneaux ?</h2>
          <span>Cliquez sur votre toiture puis tracez le contour de la zone où vous souhaitez installer vos panneaux afin d’estimer la surface disponible pour votre installation.</span>
        </div>
        <Button variant={'outlined' + (resetVisible ? '' : ' hidden')} onclick={handleReset}>Recommencer le tracé</Button>
        <Button 
          IconAfter={IconArrow} 
          variant={surface ? '' : 'outlined thin light'} 
          link={surface ? '/simulateur/informations' : null}
          onclick={setSurfaceSelection}
        >Valider ma surface</Button>
      </div>
    </>
  )
}

export default SurfaceStep;